import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import styles from './CheckMark.module.scss';

const CheckMark = ({ text }) => {
	return (
		<FlexBox alignItems='baseline'>
			<FlexBox alignItems='center' className={styles.checkMark} justifyContent='center'>
				<Icon color='success' icon='fa-check' iconWeight='fas' size='xxs' />
			</FlexBox>
			<Spacer width='s' />
			<div>{text}</div>
		</FlexBox>
	);
};

CheckMark.propTypes = {
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default CheckMark;
